(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ecru-brand-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ecru-brand-marquee')) {
    customElements.define('ecru-brand-marquee', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const viewport = this.querySelector('.ecru-brands__window');
        const group = this.querySelector('.ecru-brands__group');
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        if (!viewport || !group) return;
        this.setAttribute('data-ready', '');
        let width = group.getBoundingClientRect().width;
        let position = width;
        viewport.scrollLeft = position;
        let hover = false, focus = false, touching = false, visible = false;
        let reducedByChoice = false;
        try { reducedByChoice = localStorage.getItem('ecru-reduce-motion') === 'true'; } catch (error) {}
        document.addEventListener('ecru:motion-preference', event => { reducedByChoice = event.detail.reduce; }, {signal});
        let holdUntil = 0, pointer = null, suppressClick = false, last = 0;
        const hold = () => { holdUntil = performance.now() + 8000; position = viewport.scrollLeft; };
        this.resize = new ResizeObserver(() => {
          width = group.getBoundingClientRect().width;
          position = viewport.scrollLeft;
        });
        this.resize.observe(group);
        this.observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; });
        this.observer.observe(this);
        this.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') hover = true; }, {signal});
        this.addEventListener('pointerleave', () => { hover = false; if (!suppressClick) pointer = null; }, {signal});
        this.addEventListener('focusin', () => { focus = true; }, {signal});
        this.addEventListener('focusout', e => { focus = this.contains(e.relatedTarget); }, {signal});
        viewport.addEventListener('wheel', hold, {signal, passive: true});
        viewport.addEventListener('scroll', () => { if (hover || focus || touching || performance.now() < holdUntil) position = viewport.scrollLeft; }, {signal, passive: true});
        viewport.addEventListener('dragstart', e => e.preventDefault(), {signal});
        viewport.addEventListener('pointerdown', e => {
          if (e.button !== 0) return;
          touching = true; hold(); suppressClick = false;
          if (e.pointerType === 'mouse') pointer = {id: e.pointerId, x: e.clientX, scroll: viewport.scrollLeft};
        }, {signal});
        viewport.addEventListener('pointermove', e => {
          if (!pointer || pointer.id !== e.pointerId) return;
          const delta = e.clientX - pointer.x;
          if (Math.abs(delta) < 6 && !suppressClick) return;
          if (!suppressClick) viewport.setPointerCapture(e.pointerId);
          suppressClick = true;
          this.setAttribute('data-dragging', '');
          viewport.scrollLeft = pointer.scroll - delta;
          position = viewport.scrollLeft;
        }, {signal});
        const finish = () => {
          if (pointer && viewport.hasPointerCapture(pointer.id)) viewport.releasePointerCapture(pointer.id);
          pointer = null; touching = false; this.removeAttribute('data-dragging'); hold();
        };
        viewport.addEventListener('pointerup', finish, {signal});
        viewport.addEventListener('pointercancel', finish, {signal});
        viewport.addEventListener('lostpointercapture', finish, {signal});
        viewport.addEventListener('click', e => { if (suppressClick) {e.preventDefault(); e.stopPropagation(); suppressClick = false;} }, {signal, capture: true});
        viewport.addEventListener('keydown', e => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
          e.preventDefault(); hold();
          if (e.key === 'Home' || e.key === 'End') viewport.scrollLeft = e.key === 'Home' ? width : width * 2 - viewport.clientWidth;
          else viewport.scrollBy({left: (e.key === 'ArrowRight' ? 1 : -1) * 240, behavior: motion.matches ? 'instant' : 'smooth'});
        }, {signal});
        const tick = now => {
          const elapsed = last ? Math.min(now - last, 50) : 0;
          last = now;
          if (visible && !document.hidden && !motion.matches && !reducedByChoice && !hover && !focus && !touching && now > holdUntil && width > 0) {
            position += elapsed * .025;
            if (position >= width * 2) position -= width;
            if (position < width) position += width;
            viewport.scrollLeft = position;
          } else position = viewport.scrollLeft;
          this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); this.observer?.disconnect(); cancelAnimationFrame(this.frame); this.removeAttribute('data-ready'); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecru-travel-edit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ecru-travel-gallery')) {
    customElements.define('ecru-travel-gallery', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort(); this.abort = new AbortController();
        const controls = this.querySelector('.ecru-travel-edit__views');
        if (!controls) return;
        controls.hidden = false;
        const front = this.querySelector('.ecru-travel-edit__front');
        const alternate = this.querySelector('.ecru-travel-edit__alternate');
        controls.addEventListener('click', event => {
          const button = event.target.closest('button[data-view]');
          if (!button) return;
          const showAlternate = button.dataset.view === 'alternate';
          front.hidden = showAlternate; alternate.hidden = !showAlternate;
          controls.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        }, {signal: this.abort.signal});
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecrue-offer-ticker"]) return;
  try {
    
if (!customElements.get('ecrue-offer-ticker')) {
  customElements.define('ecrue-offer-ticker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.updateSpeed = () => {
        const width = this.querySelector('.ecrue-ticker__group').getBoundingClientRect().width;
        if (width > 0) this.style.setProperty('--ecrue-ticker-duration', (width / (Math.max(1, Number(this.dataset.speed) || 4) * 8)) + 's');
      };
      this.resizeObserver = new ResizeObserver(this.updateSpeed);
      this.resizeObserver.observe(this.querySelector('.ecrue-ticker__group'));
      this.updateSpeed();
      this.motionHandler = event => { this.dataset.reduced = String(event.detail.reduce); };
      document.addEventListener('ecru:motion-preference', this.motionHandler);
      try { this.dataset.reduced = String(localStorage.getItem('ecru-reduce-motion') === 'true'); } catch {}
    }
    disconnectedCallback() { document.removeEventListener('ecru:motion-preference', this.motionHandler); this.resizeObserver?.disconnect(); this.ready = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecrue-policy"] && !Shopify.designMode) return;
  try {
    
function initialiseEcruePolicyLanguage() {
  try {
    const language = sessionStorage.getItem('ecrue-policy-language');
    if (language !== 'ar' && language !== 'en') return;
    document.querySelectorAll('.ecrue-journal__radio').forEach(input => {
      input.checked = input.value === language;
    });
  } catch {}
}
initialiseEcruePolicyLanguage();
document.addEventListener('shopify:section:load', initialiseEcruePolicyLanguage);
document.addEventListener('change', event => {
  if (!event.target.matches('.ecrue-journal__radio')) return;
  try {
    sessionStorage.setItem('ecrue-policy-language', event.target.value);
  } catch {}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecrue-welcome-game"]) return;
  try {
    

if (!customElements.get('ecrue-welcome-game')) {
  customElements.define('ecrue-welcome-game', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.copy = JSON.parse(this.querySelector('[data-copy]').content.textContent);
      this.storageKey = 'ecrue_welcome_v1_last_shown';
      this.claimedKey = 'ecrue_welcome_v1_claimed';
      this.pendingKey = 'ecrue_welcome_signup_pending';
      this.force = this.dataset.themeId === '190801346836' && new URLSearchParams(location.search).get('ecrue_welcome_preview') === '1';
      this.querySelectorAll('[data-close]').forEach(b => b.addEventListener('click', () => this.dialog.close()));
      this.dialog.addEventListener('close', () => { document.documentElement.style.overflow = this.oldOverflow || ''; });
      this.querySelectorAll('[data-card]').forEach(b => b.addEventListener('click', () => this.choose(b)));
      this.form.addEventListener('submit', event => {
        if (!this.form.reportValidity()) { event.preventDefault(); return; }
        try { sessionStorage.setItem(this.pendingKey, JSON.stringify({ at: Date.now(), path: location.pathname, scroll: scrollY })); }
        catch { event.preventDefault(); this.querySelector('[data-message]').textContent = this.copy.error; }
      });
      this.querySelector('[data-use]').addEventListener('click', () => this.dialog.close());
      this.querySelector('[data-retry]').addEventListener('click', () => this.applyGift());
      const status = this.querySelector('[data-result]').dataset.result;
      let pending;
      try { pending = JSON.parse(sessionStorage.getItem(this.pendingKey)); } catch {}
      if (pending && Date.now() - pending.at < 1800000 && status === 'success') {
        this.show(true); this.revealReward(); this.applyGift(); return;
      }
      if (pending && status === 'error') { this.show(true); this.choose(this.querySelector('[data-card]')); return; }
      if (this.force) { this.show(true); return; }
      if (this.dataset.enabled !== 'true' || this.dataset.knownCustomer === 'true') return;
      if (/\/(cart|checkout|account|challenge)(\/|$)/.test(location.pathname)) return;
      this.timer = setTimeout(() => this.show(), Math.max(8, Number(this.dataset.delay) || 12) * 1000);
    }
    disconnectedCallback() { clearTimeout(this.timer); if (this.dialog?.open) { this.dialog.close(); document.documentElement.style.overflow = this.oldOverflow || ''; } }
    allowed() {
      try { const last = Number(localStorage.getItem(this.storageKey) || 0); return localStorage.getItem(this.claimedKey) !== '1' && Date.now() - last >= 86400000; } catch { return false; }
    }
    show(force = false) {
      if (!this.isConnected || this.dialog.open) return;
      if (!force && (!this.allowed() || document.visibilityState !== 'visible' || document.querySelector('dialog[open], [aria-modal="true"]'))) return;
      try { localStorage.setItem(this.storageKey, String(Date.now())); } catch { if (!force) return; }
      this.oldOverflow = document.documentElement.style.overflow;
      this.dialog.showModal(); document.documentElement.style.overflow = 'hidden';
    }
    revealReward() {
      this.querySelector('[data-cards]').hidden = true;
      this.querySelector('[data-intro]').hidden = true;
      this.querySelector('[data-reward]').hidden = false;
    }
    choose(button) {
      if (this.chosen) return;
      this.chosen = button.dataset.card;
      button.setAttribute('aria-pressed', 'true');
      this.revealReward();
      this.querySelector('[data-form-panel]').hidden = false;
      this.querySelector('[data-submit]').disabled = false;
      this.form.elements['contact[first_name]'].focus();
    }
    async applyGift() {
      if (this.busy) return;
      this.busy = true;
      this.querySelector('[data-form-panel]').hidden = true;
      this.querySelector('[data-applying]').hidden = false;
      this.querySelector('[data-retry]').hidden = true;
      this.querySelector('[data-apply-message]').textContent = this.copy.pending;
      try {
        const root = this.dataset.root || '/';
        const target = root + 'discount/' + encodeURIComponent(this.dataset.discount) + '?redirect=' + encodeURIComponent(root + 'cart');
        const response = await fetch(target, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(20000) });
        const finalUrl = new URL(response.url);
        if (!response.ok || finalUrl.origin !== location.origin || !/\/cart\/?$/.test(finalUrl.pathname)) throw new Error('discount redirect failed');
        try { localStorage.setItem(this.claimedKey, '1'); sessionStorage.removeItem(this.pendingKey); } catch {}
        this.querySelector('[data-applying]').hidden = true;
        this.querySelector('[data-success]').hidden = false;
        this.querySelector('[data-use]').focus();
        const clean = new URL(location.href); clean.searchParams.delete('customer_posted'); clean.searchParams.delete('ecrue_welcome_preview'); clean.hash = '';
        history.replaceState(null, '', clean.pathname + clean.search);
      } catch { this.querySelector('[data-apply-message]').textContent = this.copy.apply_error; this.querySelector('[data-retry]').hidden = false; }
      finally { this.busy = false; }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
